<template>
  <custom-popup
    v-model="dialog"
    max-width="610"
    :cons="{
      title: 'انتخاب قالب آماده',
      icon: 'palette-swatch'
    }"
    hide-confirm
  >
    <v-row class="ma-0 pa-4">
      <v-col
        v-for="template in templates"
        :key="template.id"
        cols="4"
        sm="3"
        md="2"
        class="pa-2 d-flex justify-center"
      >
        <v-card 
          @click="selectTemplate(template)"
          class="template-pattern d-flex flex-column align-center justify-center pa-2 cursor-pointer"
          width="100%"
          height="90"
          flat
          elevation="8"
        >
          <v-img
            :src="template.thumbnail"
            width="64"
            height="64"
            contain
            class="mb-2 pa-1"
          />
          <span class="caption text-center font-weight-bold" style="font-size: 8px !important; line-height: 1.2; color: #333;">
            {{ template.name }}
          </span>
        </v-card>
      </v-col>
    </v-row>
  </custom-popup>
</template>

<script>

export default {
  name: "QrCodeTemplates",
  
  props: {
    value: Boolean, 
  },
  
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  data() {
    return {
      templates: [
  {
    id: 1,
    name: "نئون سایبری",
    thumbnail: "inline-icon/1.webp",
    config: {
      image: null,
      dotsOptions: {
        type: "classy-rounded",
        color: "#DAD299FF", 
        gradient: { type: "linear", rotation: 0.78, colorStops: [{ offset: 0, color: "#B0DAB9FF" }, { offset: 1, color: "#DAD299FF" }] }
      },
      dotsOptionsHelper: {
        colorType: { single: false, gradient: true },
        gradient: { linear: true, radial: false, color1: "#DAD299FF", color2: "#B0DAB9FF", rotation: "0.78" }
      },
      cornersSquareOptions: { 
        type: "vortex2", 
        color: "#566D5B", // صورتی نئون برای کادر چشم
        gradient: null 
      },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#566D5B", color2: "#739179", rotation: "0" }
      },
      cornersDotOptions: { 
        type: "vortex", 
        color: "#B0DAB9FF", // زرد نئون برای نقطه چشم
        gradient: null 
      },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#ffdf00", color2: "#ffdf00", rotation: "0" }
      },
      backgroundOptions: { 
        color: "#0B0C1000", // مشکی متمایل به سورمه‌ای
        gradient: null
      },
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#0b0c10", color2: "#0b0c10", rotation: "0" }
      }
    }
  },

  {
    id: 2,
    name: "غروب تابستان",
    thumbnail: "inline-icon/2.webp",
    config: {
      image: null,
      dotsOptions: {
        type: "extra-rounded",
        color: "#ff512f",
        gradient: { type: "linear", rotation: 1.57, colorStops: [{ offset: 0, color: "#f09819" }, { offset: 1, color: "#ff512f" }] } 
      },
      dotsOptionsHelper: {
        colorType: { single: false, gradient: true },
        gradient: { linear: true, radial: false, color1: "#f09819", color2: "#ff512f", rotation: "1.57" }
      },
      cornersSquareOptions: { 
        type: "dropeyeright", 
        color: "#571E04FF", // بنفش تیره غروب
        gradient: null
      },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#4a00e0", color2: "#4a00e0", rotation: "0" }
      },
      cornersDotOptions: { 
        type: "dropeye", 
        color: "#f09819", // پرتقالی روشن
        gradient: null
      },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#f09819", color2: "#f09819", rotation: "0" }
      },
      backgroundOptions: { 
        color: "#fff4e6", // هلویی بسیار روشن
        gradient: null
      },
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#fff4e6", color2: "#fff4e6", rotation: "0" }
      }
    }
  },

  // Template 27: مینیمال مونوکروم (Monochrome Elegance) - رسمی، شیک و شرکتی
  {
    id: 3,
    name: "مینیمال مونوکروم",
    thumbnail: "inline-icon/3.webp",
    config: {
      image: null,
      dotsOptions: {
        type: "classy-rounded",
        color: "#2C3E50", // سرمه‌ای مایل به خاکستری تیره
        gradient: null
      },
      dotsOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#2C3E50", color2: "#2C3E50", rotation: "0" }
      },
      cornersSquareOptions: { 
        type: "square", 
        color: "#1A252F", // رنگ تیره‌تر برای کادر
        gradient: null
      },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#1A252F", color2: "#1A252F", rotation: "0" }
      },
      cornersDotOptions: { 
        type: "square", 
        color: "#2C3E50", // هم‌رنگ نقطه‌ها
        gradient: null
      },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#2C3E50", color2: "#2C3E50", rotation: "0" }
      },
      backgroundOptions: { 
        color: "#F8F9FA", // سفید مایل به طوسی (کثیف)
        gradient: null
      },
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#F8F9FA", color2: "#F8F9FA", rotation: "0" }
      }
    }
  },

  // Template 28: تمشک آبی (Berry Splash) - ترکیب آبی و ارغوانی خنک
  {
    id: 4,
    name: "صدای طلایی",
    thumbnail: "inline-icon/4.webp",
    config: {
      image: null,
      dotsOptions: {
        type: "circle",
        color: "#A77A06FF",
        gradient: { type: "radial", rotation: 0, colorStops: [{ offset: 0, color: "#BC8803FF" }, { offset: 1, color: "#A77A06FF" }] }
      },
      dotsOptionsHelper: {
        colorType: { single: false, gradient: true },
        gradient: { linear: false, radial: true, color1: "#A77A06FF", color2: "#BC8803FF", rotation: "0" }
      },
      cornersSquareOptions: { 
        type: "rounded", 
        color: "#000000", // آبی روشن برای کادر
        gradient: null
      },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#000000", color2: "#000000", rotation: "0" }
      },
      cornersDotOptions: { 
        type: "danger", 
        color: "#000000", // بنفش تمشکی
        gradient: null
      },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#000000", color2: "#000000", rotation: "0" }
      },
      backgroundOptions: { 
        color: "#ffffff",
        gradient: null
      },
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#ffffff", color2: "#ffffff", rotation: "0" }
      }
    }
  },

  // Template 29: رایحه قهوه (Coffee Roaster) - صمیمی، کلاسیک و کافه‌ای
  {
    id: 5,
    name: "رایحه قهوه",
    thumbnail: "inline-icon/5.webp",
    config: {
      image: null,
      dotsOptions: {
        type: "diamond",
        color: "#5C4033", 
        gradient: { type: "linear", rotation: 0.9, colorStops: [{ offset: 0, color: "#A0522D" }, { offset: 1, color: "#5C4033" }] }
      },
      dotsOptionsHelper: {
        colorType: { single: false, gradient: true },
        gradient: { linear: true, radial: false, color1: "#A0522D", color2: "#5C4033", rotation: "0.9" }
      },
      cornersSquareOptions: { 
        type: "extra-rounded", 
        color: "#3E2723", // قهوه‌ای اسپرسو
        gradient: null
      },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#3E2723", color2: "#3E2723", rotation: "0" }
      },
      cornersDotOptions: { 
        type: "diamond", 
        color: "#D2691E", // کاراملی
        gradient: null
      },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#D2691E", color2: "#D2691E", rotation: "0" }
      },
      backgroundOptions: { 
        color: "#F5F5DC", // کرم/بژ
        gradient: null
      },
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#F5F5DC", color2: "#F5F5DC", rotation: "0" }
      }
    }
  },


  // Template 31: پشمک پاستلی (Cotton Candy) - ملایم و فانتزی
  {
    id: 6,
    name: "پشمک پاستلی",
    thumbnail: "inline-icon/6.webp",
    config: {
      image: null,
      dotsOptions: {
        type: "rounded",
        color: "#ffc3a0",
        gradient: { type: "linear", rotation: 0.25, colorStops: [{ offset: 0, color: "#ffafbd" }, { offset: 1, color: "#ffc3a0" }] }
      },
      dotsOptionsHelper: {
        colorType: { single: false, gradient: true },
        gradient: { linear: true, radial: false, color1: "#ffafbd", color2: "#ffc3a0", rotation: "0.25" }
      },
      cornersSquareOptions: { 
        type: "rounded", 
        color: "#ffafbd", // صورتی پاستلی
        gradient: null
      },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#ffafbd", color2: "#ffafbd", rotation: "0" }
      },
      cornersDotOptions: { 
        type: "circle", 
        color: "#a1c4fd", // آبی پاستلی
        gradient: null
      },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#a1c4fd", color2: "#a1c4fd", rotation: "0" }
      },
      backgroundOptions: { 
        color: "#ffffff",
        gradient: null
      },
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#ffffff", color2: "#ffffff", rotation: "0" }
      }
    }
  },

  // Template 32: درخشش نیمه‌شب (Midnight Glow) - لوکس و رازآلود
  {
    id: 7,
    name: "درخشش نیمه‌شب",
    thumbnail: "inline-icon/7.webp",
    config: {
      image: null,
      dotsOptions: {
        type: "classy",
        color: "#F39C12", // زرد/نارنجی طلایی
        gradient: null
      },
      dotsOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#F39C12", color2: "#F39C12", rotation: "0" }
      },
      cornersSquareOptions: { 
        type: "extra-rounded", 
        color: "#F1C40F", // طلایی روشن
        gradient: null
      },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#F1C40F", color2: "#F1C40F", rotation: "0" }
      },
      cornersDotOptions: { 
        type: "star", 
        color: "#F39C12",
        gradient: null
      },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#F39C12", color2: "#F39C12", rotation: "0" }
      },
      backgroundOptions: { 
        color: "#191970", // سرمه‌ای تیره نیمه‌شب
        gradient: null
      },
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#191970", color2: "#191970", rotation: "0" }
      }
    }
  },

  // Template 33: یاقوت سرخ (Ruby Romance) - گرم، پرشور و جذاب
  {
    id: 8,
    name: "یاقوت سرخ",
    thumbnail: "inline-icon/8.webp",
    config: {
      image: null,
      dotsOptions: {
        type: "heart",
        color: "#ed213a",
        gradient: { type: "radial", rotation: 0, colorStops: [{ offset: 0, color: "#93291E" }, { offset: 1, color: "#ed213a" }] }
      },
      dotsOptionsHelper: {
        colorType: { single: false, gradient: true },
        gradient: { linear: false, radial: true, color1: "#93291E", color2: "#ed213a", rotation: "0" }
      },
      cornersSquareOptions: { 
        type: "rounded", 
        color: "#5B1610", // قرمز زرشکی خیلی تیره
        gradient: null
      },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#5B1610", color2: "#5B1610", rotation: "0" }
      },
      cornersDotOptions: { 
        type: "heart", 
        color: "#ed213a", // قرمز یاقوتی روشن
        gradient: null
      },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#ed213a", color2: "#ed213a", rotation: "0" }
      },
      backgroundOptions: { 
        color: "#FDF5F6", // سفید با هاله محو صورتی
        gradient: null
      },
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#FDF5F6", color2: "#FDF5F6", rotation: "0" }
      }
    }
  },

  // Template 34: رترو ویو (Retro Wave) - سبک دهه ۸۰، پرانرژی
  {
    id: 9,
    name: "رترو ویو",
    thumbnail: "inline-icon/9.webp",
    config: {
      image: null,
      dotsOptions: {
        type: "square",
        color: "#f12711",
        gradient: { type: "linear", rotation: 1.57, colorStops: [{ offset: 0, color: "#f5af19" }, { offset: 1, color: "#f12711" }] }
      },
      dotsOptionsHelper: {
        colorType: { single: false, gradient: true },
        gradient: { linear: true, radial: false, color1: "#f5af19", color2: "#f12711", rotation: "1.57" }
      },
      cornersSquareOptions: { 
        type: "square", 
        color: "#c21500", // قرمز تیره
        gradient: null
      },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#c21500", color2: "#c21500", rotation: "0" }
      },
      cornersDotOptions: { 
        type: "square", 
        color: "#00F2FE", // آبی فیروزه‌ای تضاد شدید
        gradient: null
      },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#00F2FE", color2: "#00F2FE", rotation: "0" }
      },
      backgroundOptions: { 
        color: "#2b0f4c", // بنفش بادمجانی تیره
        gradient: null
      },
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#2b0f4c", color2: "#2b0f4c", rotation: "0" }
      }
    }
  },
  {
    id: 10,
    name: "شب",
    thumbnail: "inline-icon/10.webp",
    config: {
      image: null,
      dotsOptions: {
        type: "vortex",
        color: "#5433FF", // رنگ پشتیبان
        gradient: { type: "radial", rotation: 0, colorStops: [{ offset: 0, color: "#f0ecfc" }, { offset: 1, color: "#5433FF" }] }
      },
      dotsOptionsHelper: {
        colorType: { single: false, gradient: true },
        gradient: { linear: false, radial: true, color1: "#f0ecfc", color2: "#5433FF", rotation: "0" }
      },
      cornersSquareOptions: { 
        type: "blob", 
        color: "#FFD700", // طلایی برای چشم
        gradient: null 
      },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#FFD700", color2: "#FFD700", rotation: "0" }
      },
      cornersDotOptions: { 
        type: "star", 
        color: "#FFA500", // نارنجی برای نقطه
        gradient: null 
      },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#FFA500", color2: "#FFA500", rotation: "0" }
      },
      backgroundOptions: { 
        color: "#0C0919", // سرمه‌ای تیره
        gradient: null
      },
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#0C0919", color2: "#0C0919", rotation: "0" }
      }
    }
  },
  // Template 20: ماتریس دیجیتال (Digital Matrix) - رنگ‌های سبز نئونی و مشکی
  {
    id: 11,
    name: "ماتریس دیجیتال",
    thumbnail: "inline-icon/11.webp",
    config: {
      image: null,
      dotsOptions: {
        type: "square",
        color: "#00FF00", // سبز روشن
        gradient: { type: "linear", rotation: 1.57, colorStops: [{ offset: 0, color: "#00FF00" }, { offset: 1, color: "#00A000" }] } // گرادیان سبز
      },
      dotsOptionsHelper: {
        colorType: { single: false, gradient: true },
        gradient: { linear: true, radial: false, color1: "#00FF00", color2: "#00A000", rotation: "1.57" }
      },
      cornersSquareOptions: { 
        type: "square", 
        color: "#00FF00", // سبز روشن برای چشم
        gradient: null 
      },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#00FF00", color2: "#00FF00", rotation: "0" }
      },
      cornersDotOptions: { 
        type: "square", 
        color: "#00FF00", // سبز روشن برای نقطه
        gradient: null 
      },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#00FF00", color2: "#00FF00", rotation: "0" }
      },
      backgroundOptions: { 
        color: "#000000", // مشکی
        gradient: null
      },
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#000000", color2: "#000000", rotation: "0" }
      }
    }
  },

  // Template 21: فلز مایع (Liquid Metal) - رنگ‌های متالیک و براق
  {
    id: 12,
    name: "فلز مایع",
    thumbnail: "inline-icon/12.webp",
    config: {
      image: null,
      dotsOptions: {
        type: "drop",
        color: "#707070", // خاکستری فلزی
        gradient: { type: "linear", rotation: 0.25, colorStops: [{ offset: 0, color: "#d7d7d7" }, { offset: 1, color: "#707070" }] } // گرادیان متالیک
      },
      dotsOptionsHelper: {
        colorType: { single: false, gradient: true },
        gradient: { linear: true, radial: false, color1: "#d7d7d7", color2: "#707070", rotation: "0.25" }
      },
      cornersSquareOptions: { 
        type: "rounded", 
        color: "#A9A9A9", // خاکستری تیره برای چشم
        gradient: null
      },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#A9A9A9", color2: "#A9A9A9", rotation: "0" }
      },
      cornersDotOptions: { 
        type: "drop_in", 
        color: "#D3D3D3", // خاکستری روشن برای نقطه
        gradient: null
      },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#D3D3D3", color2: "#D3D3D3", rotation: "0" }
      },
      backgroundOptions: { 
        color: "#1c1c1c", // مشکی زغالی
        gradient: null
      },
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#1c1c1c", color2: "#1c1c1c", rotation: "0" }
      }
    }
  },

  
  // Template 23: باغ اسرارآمیز (Secret Garden) - رنگ‌های سبز و خاکی
  {
    id: 13,
    name: "باغ اسرارآمیز",
    thumbnail: "inline-icon/13.webp",
    config: {
      image: null,
      dotsOptions: {
        type: "leaf",
        color: "#00416A", // سبز جنگلی
        gradient: { type: "linear", rotation: 0, colorStops: [{ offset: 0, color: "#00416A" }, { offset: 1, color: "#799F0C" }] } // گرادیان سبز
      },
      dotsOptionsHelper: {
        colorType: { single: false, gradient: true },
        gradient: { linear: true, radial: false, color1: "#00416A", color2: "#799F0C", rotation: "0" }
      },
      cornersSquareOptions: { 
        type: "rounded", 
        color: "#799F0C", // سبز زیتونی برای چشم
        gradient: null
      },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#799F0C", color2: "#799F0C", rotation: "0" }
      },
      cornersDotOptions: { 
        type: "flower", 
        color: "#8B4513", // قهوه‌ای خاکی برای نقطه
        gradient: null
      },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#8B4513", color2: "#8B4513", rotation: "0" }
      },
      backgroundOptions: { 
        color: "#F5F5DC", // بژ روشن
        gradient: null
      },
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#F5F5DC", color2: "#F5F5DC", rotation: "0" }
      }
    }
  },
    {
    id: 14,
    name: "دروازه کهکشان",
    thumbnail: "inline-icon/14.webp",
    config: {
      image: null,
      dotsOptions: {
        type: "vortex",
        color: "#5433FF", // رنگ پشتیبان
        gradient: { type: "radial", rotation: 0, colorStops: [{ offset: 0, color: "#f0ecfc" }, { offset: 1, color: "#5433FF" }] }
      },
      dotsOptionsHelper: {
        colorType: { single: false, gradient: true },
        gradient: { linear: false, radial: true, color1: "#f0ecfc", color2: "#5433FF", rotation: "0" }
      },
      cornersSquareOptions: { 
        type: "blob", 
        color: "#2B1B82",
        gradient: null // خنثی کردن رنگ پیش‌فرض سیستم
      },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#2B1B82", color2: "#2B1B82", rotation: "0" }
      },
      cornersDotOptions: { 
        type: "star", 
        color: "#f0ecfc",
        gradient: null // خنثی کردن رنگ پیش‌فرض سیستم
      },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#f0ecfc", color2: "#f0ecfc", rotation: "0" }
      },
      backgroundOptions: { 
        color: "#0C091D",
        gradient: null
      },
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#0C091D", color2: "#0C091D", rotation: "0" }
      }
    }
  },
  {
    id: 15,
    name: "سایبرپانک دارک",
    thumbnail: "inline-icon/15.webp",
    config: {
      image: null,
      dotsOptions: {
        type: "classy",
        gradient: { type: "linear", rotation: 1, colorStops: [{ offset: 0, color: "#8A2387" }, { offset: 1, color: "#F27121" }] }
      },
      dotsOptionsHelper: {
        colorType: { single: false, gradient: true },
        gradient: { linear: true, radial: false, color1: "#8A2387", color2: "#F27121", rotation: "1" }
      },
      cornersSquareOptions: {
        type: "classy-rounded",
        color: "#E94057"
      },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#E94057", color2: "#E94057", rotation: "0" }
      },
      cornersDotOptions: {
        type: "diamond",
        color: "#8A2387"
      },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#8A2387", color2: "#8A2387", rotation: "0" }
      },
      backgroundOptions: { color: "#121212" }, // دارک مد
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#121212", color2: "#121212", rotation: "0" }
      }
    }
  },
  {
    id: 16,
    name: "طلوع خورشید (گرادیان)",
    thumbnail: "inline-icon/16.webp",
    config: {
      image: null,
      dotsOptions: { 
        type: "classy", 
        gradient: {
          type: "linear",
          rotation: 0.785, // 45 degrees
          colorStops: [{ offset: 0, color: "#ff512f" }, { offset: 1, color: "#dd2476" }] // نارنجی به صورتی
        }
      },
      cornersSquareOptions: { 
        type: "classy-rounded", 
        gradient: {
          type: "linear",
          rotation: 0,
          colorStops: [{ offset: 0, color: "#dd2476" }, { offset: 1, color: "#ff512f" }]
        }
      },
      cornersDotOptions: { type: "diamond", color: "#dd2476" },
      backgroundOptions: { color: "#FFFFFF" }
    }
  },
  {
    id: 17,
    name: "لوکس و طلایی",
    thumbnail: "inline-icon/17_1.webp", 
    config: {
      image: "/logos/1 (2).jpg", // می‌توانید لوگوی طلایی/مشکی قرار دهید
      imageOptions: { hideBackgroundDots: true, imageSize: 0.4, margin: 2 },
      dotsOptions: { 
        type: "diamond", 
        gradient: {
          type: "linear",
          rotation: 1.57, // 90 degrees
          colorStops: [{ offset: 0, color: "#BF953F" }, { offset: 1, color: "#FCF6BA" }] // طیف طلایی
        }
      },
      cornersSquareOptions: { type: "special-diamond", color: "#BF953F" },
      cornersDotOptions: { type: "star", color: "#FCF6BA" },
      backgroundOptions: { color: "#1a1a1a" } // پس‌زمینه مشکی/دودی
    }
  },
  {


    name: "طبیعت و محیط زیست",
    thumbnail: "inline-icon/17.webp",
    config: {
      image: null,
      dotsOptions: {
        type: "leaf",
        color: "#00416A", // سبز جنگلی
        gradient: { type: "linear", rotation: 0, colorStops: [{ offset: 0, color: "#11998e" }, { offset: 1, color: "#38ef7d" }] } // گرادیان سبز
      },
      dotsOptionsHelper: {
        colorType: { single: false, gradient: true },
        gradient: { linear: true, radial: false, color1: "#11998e", color2: "#38ef7d", rotation: "0" }
      },
      cornersSquareOptions: { 
        type: "flower", 
        color: "#11998e", // سبز زیتونی برای چشم
        gradient: null
      },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#11998e", color2: "#11998e", rotation: "0" }
      },
      cornersDotOptions: { 
        type: "flower", 
        color: "#38ef7d", // قهوه‌ای خاکی برای نقطه
        gradient: null
      },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#38ef7d", color2: "#38ef7d", rotation: "0" }
      },
      backgroundOptions: { 
        color: "#f1f8e9", // بژ روشن
        gradient: null
      },
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: { linear: true, radial: false, color1: "#F5F5DC", color2: "#F5F5DC", rotation: "0" }
      }
    }
  },
  {
    id: 19,
    name: "قطره و شبنم",
    thumbnail: "inline-icon/18.webp",
    config: {
      image: null,
      dotsOptions: { 
        type: "drop", 
        gradient: {
          type: "linear",
          rotation: 0,
          colorStops: [{ offset: 0, color: "#8CA6DB" }, { offset: 1, color: "#B993D6" }] 
        }
      },
      cornersSquareOptions: { type: "dropeye", color: "#8CA6DB" },
      cornersDotOptions: { type: "drop_in", color: "#B993D6" },
      backgroundOptions: { color: "#FAFAFA" }
    }
  },
  {
    id: 19,
    name: "عاشقانه (ولنتاین)",
    thumbnail: "inline-icon/19.webp",
    config: {
      image: null,
      dotsOptions: { 
        type: "heart", 
        gradient: {
          type: "linear",
          rotation: 0,
          colorStops: [{ offset: 0, color: "#ff0844" }, { offset: 1, color: "#ffb199" }] // قرمز به صورتی ملایم
        }
      },
      cornersSquareOptions: { type: "heart", color: "#ff0844" },
      cornersDotOptions: { type: "heart", color: "#ffb199" },
      backgroundOptions: { color: "#fff0f5" } 
    }
  },
      ],
    };
  },

  methods: {
    selectTemplate(template) {
      this.$emit("select", template);
      this.dialog = false; 
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.template-pattern {
  border: 1px solid #e0e0e0 !important; 
  transition: all 0.3s ease;
  background-color: #fafafa !important;
  border-radius: 12px !important;
}

.template-pattern:hover {
  border: 1px solid #011554 !important;
  background-color: #fff8eb !important;
  transform: translateY(-3px);
  box-shadow: 0 4px 10px #000822a0 !important;
}
</style>
